const converteCFOP = (cfop)=>{
    if(cfop==='5403'){
        return('1403')
    }
    if(cfop==='6403'){
        return('2403')
    }
    if(cfop==='5102'){
        return('1102')
    }
    if(cfop==='6102'){
        return('2102')
    }
    if(cfop==='5202'){
        return('1202')
    }
    if(cfop==='6202'){
        return('2202')
    }
    if(cfop==='5405'){
        return('1403')
    }
    if(cfop==='6403'){
        return('1403')
    }
    if(cfop==='5910'){
        return('1910')
    }
    if(cfop==='6910'){
        return('2910')
    }
    if(cfop==='5152'){
        return('1152')
    }
    if(cfop==='6152'){
        return('2152')
    }
    if(cfop==='5409'){
        return('1409')
    }
    if(cfop==='6409'){
        return('2409')
    }
    if(cfop==='5909'){
        return('1908')
    }
    if(cfop==='6908'){
        return('2908')
    }
    return(cfop);
}
export default converteCFOP;